import React from "react"

import { formErrorMessage } from "@/utils/forms"

interface Props {
  errors?: boolean | Array<unknown>
}

const FormErrors: React.FC<Props> = ({ errors }) => {
  if (!errors || !Array.isArray(errors)) {
    return null
  }

  const messages = errors
    .map(formErrorMessage)
    .filter((message): message is string => message !== null)

  if (messages.length === 0) {
    return null
  }

  return (
    <div className="bg-red-200 text-red-700 p-3 rounded-lg mb-5">
      {messages.map((message, key) => (
        <div key={key}>{message}</div>
      ))}
    </div>
  )
}

export default FormErrors
